import * as types from '../../actionsTypes/dashboard/propertyDetailTypes'
import { initialValuesOwnerInventory as initialValues } from '../../../helpers/variablesInitialValues'

const initialState = {
	perPage: 20,
	page: 1,
	pages: 1,
	isLoadingTable: false,
	arrayListAlbumsTypes: [],
	arrayListAlbumsTypesFiles: [],
	formData: initialValues
}

const propertyDetailReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_PROPERTY_DETAIL:
			return {
				...state,
				perPage: payload
			}
		
		case types.PAGE_PROPERTY_DETAIL:
			return {
				...state,
				page: payload
			}
		
		case types.PAGES_PROPERTY_DETAIL:
			return {
				...state,
				pages: payload
			}
		
		case types.IS_LOADING_TABLE_PROPERTY_DETAIL:
			return {
				...state,
				isLoadingTable: payload
			}
		
		case types.ARRAY_LIST_ALBUMS_TYPES_PROPERTY_DETAIL:
			return {
				...state,
				arrayListAlbumsTypes: payload
			}
		
		case types.ARRAY_LIST_ALBUMS_TYPES_FILES_PROPERTY_DETAIL:
			return {
				...state,
				arrayListAlbumsTypesFiles: payload
			}
		
		case types.FORM_DATA_PROPERTY_DETAIL:
			return {
				...state,
				formData: payload
			}
		
		default:
			return state
	}
}

export default propertyDetailReducer
